var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeverityMinorAnomaly(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66602 6.8V5.66667L7.99935 2L13.3327 5.66667V6.8L7.99935 3.33333L2.66602 6.8Z",
    fill: "#419E98"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66602 10.132V8.9987L7.99935 5.33203L13.3327 8.9987V10.132L7.99935 6.66536L2.66602 10.132Z",
    fill: "#419E98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66602 13.4654V12.332L7.99935 8.66536L13.3327 12.332V13.4654L7.99935 9.9987L2.66602 13.4654Z",
    fill: "#419E98"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeverityMinorAnomaly);
export default __webpack_public_path__ + "static/media/severity-minor-anomaly.02f313043dcca0f1d2b69ab06e813004.svg";
export { ForwardRef as ReactComponent };